// Analytics Barrel file
// This file is used to analytics components in one place
// This simplifies importing the chart components in other parts of the application
// IMPORTANT: Please keep the components in alphabetical order

export * from './pages/chart-details-page/chart-details-page.component';
export * from './pages/custom-dashboard-page/custom-dashboard-page.component';

export * from './analytics.routing';